import { useMemo } from "react";
import { useParams } from "react-router-dom";
import UserLinkedMachineList from "./components/list/index";
import UserDetails from "./components/details/index";
import { getAllUserRelatedMachines } from "./helper";
import { ScreenOverlay, Spinner } from "../../components/Common";
import { useUser } from "../../common/hooks/api/user";
import { toastError } from "../../helpers/toast-helper";
import { getResponseItemData } from "../../helpers/response-helper";

const UserDetailsPage = () => {
    const { id } = useParams();
    const { data: userResponse, isLoading } = useUser(id!, {
        onError: () => {
            toastError("Cannot fetch user data");
        },
    });
    const { data } = getResponseItemData(userResponse);
    const machines = useMemo(() => data ? getAllUserRelatedMachines(data): [], [data]);

    return (
        <>
            <UserDetails data={data} />
            <UserLinkedMachineList data={machines}/>
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </>
    );
};

export default UserDetailsPage;
